/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const accountModule = require('./account/accountModule');
const adsModule = require('./ads/adsModule');
const analyticsModule = require('./analytics/analyticsModule');
const balancedColumnsModule = require('./balanced_columns/balancedColumnsModule');
const calloutBannerModule = require('./callout_banner/calloutBannerModule');
const calloutButtonModule = require('./callout_button/calloutButtonModule');
const categoriesModule = require('./categories/categoriesModule');
const categoryGuideModule = require('./category_guide/categoryGuideModule');
const cmsModule = require('./cms/cmsModule');
const commonModule = require('./common/commonModule');
const consumersModule = require('./consumers/consumersModule');
const cookiesModule = require('./cookies/cookiesModule');
const disclosuresModule = require('./disclosures/disclosuresModule');
const filtersModule = require('./filters/filtersModule');
const flatPageModule = require('./flatPage/flatPageModule');
const geoModule = require('./geo/geoModule');
const getFetchModule = require('./get_fetch/getFetchModule');
const googleMapsModule = require('./google_maps/googleMapsModule');
const histogramModule = require('./histogram/histogramModule');
const homeAdvisorModule = require('./home_advisor/homeAdvisorModule');
const socialMediaShareButtonModule = require('./social_media_share/socialMediaShareButtonModule');
const imageUtilsModule = require('./image_utils/imageUtilsModule');
const indexModule = require('./index/indexModule');
const loadersModule = require('./loaders/loadersModule');
const navigationModule = require('./navigation/navigationModule');
const productCardModule = require('./product_card/productCardModule');
const productModule = require('./product/productModule');
const rebatesModule = require('./rebates/rebatesModule');
const searchModule = require('./search/searchModule');
const solarModule = require('./solar/solarModule');
const specialOffersModule = require('./specialOffers/specialOffersModule');
const swiftypeModule = require('./swiftype/swiftypeModule');
const thirdPartyIntegrationModule = require('./third_party_integrations/thirdPartyIntegrationModule');
const utilitySelectorModule = require('./utility_selector/utilitySelectorModule');
const productSectionsModule = require('./productSections/productSectionsModule');
const productCompareModule = require('./productComparison/productCompareModule');
const claimTransactionsModule = require('./transactions/claims/claimTransactionsModule');
const orderTransactionsModule = require('./transactions/orders/orderTransactionsModule');



/**
 * Utility module for holding general common code between the main Enervee Angular applications.
 */
const utilsModule = angular.module('enervee_utils', [
    accountModule.name,
    adsModule.name,
    analyticsModule.name,
    balancedColumnsModule.name,
    calloutBannerModule.name,
    calloutButtonModule.name,
    categoriesModule.name,
    categoryGuideModule.name,
    cmsModule.name,
    commonModule.name,
    consumersModule.name,
    cookiesModule.name,
    disclosuresModule.name,
    filtersModule.name,
    flatPageModule.name,
    geoModule.name,
    getFetchModule.name,
    googleMapsModule.name,
    histogramModule.name,
    homeAdvisorModule.name,
    socialMediaShareButtonModule.name,
    imageUtilsModule.name,
    indexModule.name,
    loadersModule.name,
    navigationModule.name,
    productCardModule.name,
    productModule.name,
    rebatesModule.name,
    searchModule.name,
    solarModule.name,
    specialOffersModule.name,
    swiftypeModule.name,
    thirdPartyIntegrationModule.name,
    utilitySelectorModule.name,
    productSectionsModule.name,
    productCompareModule.name,
    claimTransactionsModule.name,
    orderTransactionsModule.name
]);

module.exports = utilsModule;
